import request from "../../utils/request";

export function doGetAllOrders(params) {
  return request("/orders", {
    method: "GET",
    params,
  });
}

export function doCreateOrder(params) {
  return request("/orders", {
    method: "POST",
    data: params,
  });
}

export function doCreateMutiOrders(params) {
  return request("/orders/create-muti-orders", {
    method: "POST",
    data: params,
  });
}

export function doUploadOrders(params) {
  return request("/orders/upload-orders", {
    method: "POST",
    data: params,
  });
}

export function doGetLastOrder() {
  return request("/orders/get-last-order", {
    method: "GET",
  });
}

export function doDeleteOrder(id) {
  return request(`/orders/${id}`, {
    method: "DELETE",
  });
}

export function doUpdateOrder(params) {
  return request(`/orders/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDetailOrder(id) {
  return request(`/orders/${id}`, {
    method: "GET",
  });
}

export function doDetailTrackingOrder(orderCode) {
  return request(`/orders/tracking/${orderCode}`, {
    method: "GET",
  });
}

export function doDetailPublicOrder(orderCode) {
  return request(`/orders/public/${orderCode}`, {
    method: "GET",
  });
}

export function doBulkDeleteOrders(params) {
  return request("/orders/bulk-delete", {
    method: "POST",
    data: params,
  });
}

export function doBulkUpdateOrders(params) {
  return request("/orders/bulk-update", {
    method: "POST",
    data: params,
  });
}

export function doBulkUpdateDeliveryDate(params) {
  return request("/orders/bulk-update-delivery-date", {
    method: "POST",
    data: params,
  });
}
